import React from "react";

const SubscriptionContext = React.createContext();
export default SubscriptionContext;
